package com.eladfinish.bible.contest.screens.pyramidCrossword.usecases

import com.eladfinish.bible.contest.constants.Constants
import com.eladfinish.bible.contest.network.spreadsheet.SpreadsheetApi
import com.eladfinish.bible.contest.network.spreadsheet.handleApiResult
import com.eladfinish.bible.contest.network.spreadsheet.toSpreadsheetMatrix
import com.eladfinish.bible.contest.screens.pyramidCrossword.model.PyramidQuestion
import com.eladfinish.bible.contest.screens.pyramidCrossword.model.PyramidSheetEntry
import com.eladfinish.bible.contest.utils.spreadsheet.getId
import kotlinx.coroutines.flow.first
import kotlinx.coroutines.flow.map

class GetPyramidsUseCase(
    private val spreadsheetApi: SpreadsheetApi,
) {

    suspend operator fun invoke(): Result<List<List<PyramidQuestion>>> =
        spreadsheetApi.getDataFromSpreadsheet(spreadsheetId = Constants.google_spreadsheet_pyramid_crossword.getId())
            .handleApiResult { result ->
                result.data.toSpreadsheetMatrix()
                    .map { list: List<List<String>> ->
                        list.map {
                            PyramidSheetEntry(
                                crosswordNumber = it[0],
                                question = it[1],
                                answer = it[2],
                                length = it[3],
                            )
                        }
                    }
                    .map(::processEntries)
                    .map(Result.Companion::success)
                    .first()
            }

    private fun processEntries(items: List<PyramidSheetEntry>): List<List<PyramidQuestion>> {
        val crosswordList: MutableList<MutableList<PyramidQuestion>> = mutableListOf()
        var records: MutableList<PyramidQuestion> = mutableListOf()
        for (item in items) {
            val num = item.crosswordNumber
            if (num.isNotEmpty() && num.toDouble() > 0) {
                if (records.isNotEmpty()) {
                    crosswordList.add(records)
                }
                records = ArrayList()
            } else {
                val pyramidQuestion = PyramidQuestion(
                    number = item.length.toDouble().toInt(),
                    question = item.question,
                    answer = item.answer,
                )
                records.add(pyramidQuestion)
            }
        }
        crosswordList.add(records)
        return crosswordList
    }

}
